import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const CommissionPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    commissionName: PropTypes.string,
    slab: PropTypes.arrayOf(PropTypes.shape({
        target: PropTypes.number,
        reward: PropTypes.number,
        isRewardPercentage: PropTypes.bool,
        achievementReward: PropTypes.number,
        isAchievementRewardPercentage: PropTypes.bool,
    })),
});

export const CommissionSlabDefaultProps = {
    achievementReward: 0,
    isRewardPercentage: true,
    isAchievementRewardPercentage: true,
};

export const CommissionDefaultProps = {
    commissionName: '',
    slab: [],
    tempSlab: { ...CommissionSlabDefaultProps },
};

export const CommissionYupSchema = Yup.object().shape({
    commissionName: Yup.string().required('Required'),
});

export default {
    CommissionSlabDefaultProps,
    CommissionDefaultProps,
    CommissionPropTypes,
    CommissionYupSchema,
};
